// Jquery, Bootstrap
require('./bootstrap');
require('./sentry')
// Plugins
require('ion-rangeslider');
require('owl.carousel');
require('@fortawesome/fontawesome-free');
require('slick-carousel');

require('@fancyapps/fancybox');

// jQuery(document).ready(function(){
//     jQuery('#ajaxSubmit').click(function(e){
//         e.preventDefault();
//         $.ajaxSetup({
//             headers: {
//                 'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
//             }
//         });
//     });
// });

// User's scripts
require('./partials/cookies');
require('./partials/cleave');
require('./functions');
require('./template/lazyLoad.min.js');
require('./template/js-range-slider.js');
require('./template/particles.min.js');
require('./template/main.js');
require('./user_scripts');
require('./template/custom_fancy.min');
require('./partials/2gis-maps');
require('./components/new-feedbacks-component');
require('./components/header-search');
require('./components/button-fancybox');
require('./components/numbers-collapse');
require('./analytics/fingerprint')
require('./analytics/notify')

